import { render, staticRenderFns } from "./dialog-alert-remark-taxbox.vue?vue&type=template&id=a7960c96&"
import script from "./dialog-alert-remark-taxbox.vue?vue&type=script&lang=js&"
export * from "./dialog-alert-remark-taxbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports